// Module
var code = `<file-upload
  ng-model="\$ctrl.innerModel"
  ng-change="\$ctrl.valueChanged()"
  file-additional-metadata="\$ctrl.fileAdditionalMetadata"
  validate="\$ctrl.validate"
  max-files="\$ctrl.maxFiles"
  max-size="\$ctrl.maxSize"
  show-file-name="\$ctrl.showFileName"
  show-remarks="\$ctrl.showRemarks"
  ng-disabled="\$ctrl.ngDisabled"
  enable-webcam="\$ctrl.enableWebcam"
  allow-duplicates="\$ctrl.allowDuplicates"
  validate-uploaded
>
</file-upload>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/file-id-upload/file-id-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;